import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { getRecordTitle } from '../utils/getRecordTitle';
import { PopoverHeader, PopoverCloseButton, PopoverBody } from 'foundations-components/transitional/components/Popover';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { useCallback } from 'react';
import getIn from 'transmute/getIn';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TagWrapper = styled.span.withConfig({
  displayName: "TagsPopoverContent__TagWrapper",
  componentId: "rkv9s1-0"
})(({
  theme
}) => `
  .tag {
    margin-left: ${theme.space['0']};
    margin-right: ${theme.space['100']};
  }
`);
const TagsPopoverContent = ({
  tags,
  object,
  objectTypeDef,
  onClosePopover
}) => {
  const title = getRecordTitle(object, objectTypeDef);
  const getAdditionalPropertyValue = useCallback(propertyName => getIn(['properties', propertyName, 'value'], object), [object]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(PopoverHeader, {
      children: [/*#__PURE__*/_jsx(H4, {
        children: title
      }), /*#__PURE__*/_jsx(PopoverCloseButton, {
        popoverUse: "longform",
        onClick: onClosePopover
      })]
    }), /*#__PURE__*/_jsxs(PopoverBody, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-data-board-card.recordTags.viewAllTags.message",
          options: {
            objectType: objectTypeDef.singularForm
          }
        })
      }), /*#__PURE__*/_jsx(TagWrapper, {
        children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
          objectTypeId: objectTypeDef.objectTypeId,
          objectId: `${object.objectId}`,
          property: tags.definition,
          value: tags.value,
          getAdditionalPropertyValue: getAdditionalPropertyValue
        })
      })]
    })]
  });
};
export default TagsPopoverContent;